import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReleaseViewConfigModalComponent } from '../../release-view-config-modal/release-view-config-modal.component';

@Component({
  selector: 'module-change-details',
  template: `
    <span class="approval__shaded__module lx-body" style="background-color: transparent;">
      <li *ngIf="!isEdit; else showState" class="lx-header" style="text-transform: none;">{{name}}</li>
      <ng-template #showState>
        <li class="lx-body-bold">{{current ? "Current" : "New"}}</li>
      </ng-template>
      <li>{{version}}</li>
      <li *ngIf="hasConfig">
        <a class="link lx-body" (click)="displayConfig(config)">View JSON Config</a>
      </li>
    </span>
  `,
  styleUrls: ['../release-approval-modal.component.scss']
})

export class ModuleChangeDetailsComponent {
  @Input() name: string;
  @Input() version: string;
  @Input() hasConfig: boolean;
  @Input() config: string;
  @Input() isEdit: boolean;
  @Input() current: boolean;

  constructor(
    public modalService: NgbModal
  ) { }

  displayConfig(config: string) {
    const modal = this.modalService.open(ReleaseViewConfigModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.headerText = `JSON Configuration`;
    modal.componentInstance.bodyText = config;
  }
}
